export default __webpack_public_path__ + "8d1b712b062e2e3db6ef0ee1d071c13e.jpg";